import { render, staticRenderFns } from "./approvalPrice.vue?vue&type=template&id=cbf32d86&scoped=true"
import script from "./approvalPrice.vue?vue&type=script&lang=js"
export * from "./approvalPrice.vue?vue&type=script&lang=js"
import style0 from "./approvalPrice.vue?vue&type=style&index=0&id=cbf32d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf32d86",
  null
  
)

export default component.exports